<router-outlet></router-outlet>
<edgvr-front-feature-notifications></edgvr-front-feature-notifications>
